import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withRouter } from "react-router";
import { Link } from 'react-router-dom';
import './Details.css';
import {getViewKey} from "../Utils";
import ItemList from "./ItemList";
import Content from "./Content";
import * as actions from "../actions/actions";
import TechList from "./TechList";
import {MODEL_PROJECTS, MODEL_SERVICES} from "../reducers/drfConnector";

class Details extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }
  view;
  id;
  key;

  componentDidMount(){
    if(this.props.tile && !this.props.id){
      this.props.selectViewId(this.id);
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.tile && nextProps.id && nextProps.id !== this.props.id){
      this.updateContent(nextProps)
    }
  }

  componentDidUpdate(prevProps){
    this.getCurrentSelection();
    if(this.props.tile && !this.props.id){
      this.props.selectViewId(this.id);
      return;
    }
    if(!this.props.tile || !this.props.id
        || this.props.error
        || !this.props.isHydrated
        || getViewKey(prevProps.tile, prevProps.id) === this.key
        || this.props.isFetchingList
    ){
      return;
    }
    console.log("update to " + this.key);
    this.updateContent(this.props)
  }

  updateContent(props) {
    if(!this.props.models[props.tile][props.id]){
      this.props.fetchList(props.tile);
      if(props.tile !== MODEL_PROJECTS){
        this.props.fetchList(MODEL_PROJECTS);
      }
    }
  }

  getCurrentSelection() {
    let view = this.props.tile;
    if(this.props.match.params.view && this.props.match.params.view !== view){
      view = this.props.match.params.view;
    }
    let id = this.props.id;
    if(this.props.match.params.viewId && this.props.match.params.viewId !== id){
      id = this.props.match.params.viewId;
    }
    this.view = view;
    this.id = id;
    this.key = getViewKey(view, id);
  }

  getItemList(contents, listView){
    const ids = contents[listView];
    let itemList = {};
    if(!ids){
      return itemList;
    }
    for(const id of ids){
      if(typeof id === "object"){
        itemList[id["id"]] = id;
        continue;
      }
      const item = this.props.models[listView][id];
      if(item){
        itemList[id] = item;
      }
    }

    return itemList;
  }

  static renderCustomer(customer, view=null)
  {
    if(customer === undefined || view !== 'projects' || customer.id < 1){
      return null;
    }
    const url = "/customers/" + customer.id;
    return Details.renderLocalUrl("Kunde", url, customer.title);
  }

  static renderProperty(url, title)
  {
    if(!url || !title){
      return null;
    }
    return this.renderRemoteUrl("Link", url, title)
  }

  static renderRemoteUrl(label, url, title)
  {
    return <div className="intro-link"><div>{label}:</div><a href={url}>{title}</a></div>;
  }

  static renderLocalUrl(label, url, title)
  {
    return <div className="intro-link"><div>{label}:</div><Link to={url}>{title}</Link></div>;
  }

  render(){
    if(this.props.error){
      return Content.renderError(this.props.error);
    }
    const items = this.props.models[this.view];
    if(!items){
      return null;
    }
    const contents = items[this.id];
    if(!contents){
      return null;
    }
    const txt = {__html:contents.description};
    let listView = MODEL_PROJECTS;
    let itemHeadline = 'Projekte';
    if(this.props.tile === MODEL_PROJECTS){
      listView = MODEL_SERVICES;
      itemHeadline = 'Leistungen';
    }
    const urlTitle = (contents.url) ? contents.url.replace(/https?:\/\//, '').replace(/\/$/, ''):undefined;
    const full_content = () => {
      return <div>
        <h1 key="headline">{contents.title}</h1>
        {Details.renderProperty(contents.url, urlTitle)}
        {Details.renderCustomer(contents.customer, this.props.tile)}
        <div key="content" dangerouslySetInnerHTML={txt}/>
        <ItemList itemList={this.getItemList(contents, listView)} itemHeadline={itemHeadline} view={listView}/>
        <TechList technologies={contents.technologies}/>
      </div>
    };
    return <div id="content">
      {Content.renderContentTransition(this.view+this.id, full_content())}
      {Content.renderFooter()}
      {Content.renderLoading(this.props.isFetchingList)}
    </div>
  }
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    tile: state.selection.tile,
    id: state.selection.id,
    error: state.drf.error,
    models: state.drf.models,
    isHydrated: state.isHydrated,
  }
};

const DetailsWithRouter = withRouter(connect(
  mapStateToProps,
  actions
)(Details));

export default DetailsWithRouter;


// WEBPACK FOOTER //
// ./src/components/Details.js